import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=60da2881&scoped=true&lang=pug&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"
import style0 from "./Error.vue?vue&type=style&index=0&id=60da2881&lang=sass&nolang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60da2881",
  null
  
)

export default component.exports